import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class UspRowConverter extends CmsConverterService<UspRowData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      items: formData.st_row_boxes ?? defaultFSCatalog,
      headline: formData.st_headline ?? defaultTextInput
    }
  }
}

export const USP_ROW_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, UspRowData>>('UspRowConverter')

export interface UspRowData extends ConvertedComponentData {
  items: FsCatalog;
  headline: TextInput;
}
